import React from 'react';
import ReactDOM from 'react-dom';
import { getFromSessionStorage } from '@dc/ui-library';
import { Provider } from 'react-redux';
import domUtils from '../domutils';
import constants from '../components/react/constants';
import AddToBasketButtonWithAjaxCall
  from '../components/react/AddToBasket/AddToBasketButtonWithAjaxCall.jsx';
import AddToBasketFailedPopupWrapper
  from '../components/react/AddToBasket/AddToBasketFailedPopup/AddToBasketFailedPopupWrapper';

function setComparePageBackLinkBehavior() {
  const backLink = domUtils.q('#compareTable .backLink');
  const backLinkLabelElement = domUtils.q('#compareTable .backLink-text');
  const previousPageURL =
    getFromSessionStorage(constants.SESSION_STORAGE_COMPARISON_LAST_PAGE_PATH);

  // it's compare page
  if (backLink) {
    if (previousPageURL) {
      const backLinkLabel =
        getFromSessionStorage(constants.SESSION_STORAGE_COMPARISON_BACK_LINK_LABEL);

      domUtils.attr(backLink, 'href', previousPageURL);

      // setting back link visible
      domUtils.addClass(backLink, 'visible');

      if (backLinkLabelElement && backLinkLabel) {
        backLinkLabelElement.innerHTML = backLinkLabel;
      }
    }
  }
}

function initAddToBasketButtons() {
  const addToBasketButtons =
    Array.from(document.querySelectorAll('[data-component="add-to-basket-button-compare"]'));

  if (addToBasketButtons) {
    addToBasketButtons.forEach((addToBasketEl) => {
      ReactDOM.render(
        <AddToBasketButtonWithAjaxCall
          fupid={addToBasketEl.dataset.fupid}
          quantity={1}
          buttonLabel={addToBasketEl.dataset.buttonLabel}
          download={addToBasketEl.hasAttribute('data-download')}
        />,
        addToBasketEl
      );
    });
  }
}

function initAddingToBasketFailedPopup() {
  const wrapperElements =
    document.querySelectorAll('[data-component="addToBasketFailedPopupWrapper"]');

  wrapperElements.forEach((wrapperElement) => {
    if (wrapperElement) {
      ReactDOM.render(
        <Provider store={window.appState}>
          <AddToBasketFailedPopupWrapper />
        </Provider>,
        wrapperElement
      );
    }
  });
}

export default function initComparePage() {
  setComparePageBackLinkBehavior();
  initAddToBasketButtons();
  initAddingToBasketFailedPopup();
}
